import {Record} from "immutable";
import {ApplicationState} from "../../reducer";
import {MODULE} from "../index";
import {RunCodyOption} from "../reducers/RunCodyOn";

export const makeRunCodyOnSelector = (): (state: Record<ApplicationState>) => RunCodyOption => (state) => state.getIn([MODULE, 'runCodyOn']);
